import { } from "jquery"
export type JqElm = JQuery<HTMLElement>
import { } from "alertify"
import { print } from "util"
import { TemplateExecutor, template } from "lodash"
import { Lazy } from "../utils/core"
import { } from "bootbox"
import { RestfulError } from "../api/api";
export type CreateElmFunc = (id?: string) => JqElm


export const UiUtils = {
    elmById(id: any, className?: string, name?: string, optSelector?: string): JqElm {
        let selector = `[data-id="${id}"]`
        if (className != null) {
            selector = `.${className}${selector}`
        }
        if (name != null) {
            selector += `[name=${name}]`
        }
        if (optSelector != null) {
            selector += optSelector
        }
        return $(selector)
    },
    getOptionValues(elm: JqElm): Array<string> {
        return elm.find('option').toArray().map(it => (it as any).value)
    },
    options(name: string, value: string): JqElm {
        return $('<option></option>').attr("value", value).text(name)
    },
    setChecked(el: JqElm, checked: boolean = true): JqElm {
        return el.prop('checked', checked)
    },
    cleanOptions(el: JqElm) {
        el.find('option').remove()
    },
    isChecked(el: JqElm): boolean {
        return el.prop('checked')
    },
    setDisabled(el: JqElm, disabled: boolean = true) {
        el.prop('disabled', disabled)
    },
    setReadOnly(el: JqElm, ro: boolean = true) {
        el.attr('readOnly', <any>ro)
    },
    prompt(options: BootboxPromptOptions) {
        return new Promise<string>(resolve => {
            options.callback = (result) => {
                resolve(result)
            }
            bootbox.prompt(options)
        })
    },
    confirm(message: string): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            alertify.confirm(message, function () {
                const yes = arguments[0]
                console.log("Confirm:%s", yes)
                resolve(yes)
            })
        })
    },
    alert(message: string): Promise<void> {
        return new Promise<void>(resolve => {
            alertify.alert(message, function () {
                resolve(null)
            })
        })
    },
    notify(waitTime: number, iconClass?: string, title?: string, text?: string, callback?: string) {
        if (iconClass == null) {
            iconClass = ''
        }
        callback = callback != null ? `onclick='${callback}'` : ''
        let titleHtml = title != null ? `<div class='title' data-notify-html='title' style='max-width:300px;'>${title}</div>` : ''
        let textHtml = text != null ? `<div class='text' data-notify-html='text'>${text}</div>` : ''
        let div = `<div ${callback} class='notifyjs-metro-base notifyjs-metro-log notifyjs-metro-success'><div class='image' data-notify-html='image'><i class='glyphicon ${iconClass}'></i></div> <div class='text-wrapper'>${titleHtml}${textHtml}</div></div>`
        alertify.log(div, 'changeInput', waitTime)
    },
    showValidationError(elm: JqElm, errorMessageFindFunc: (selector: string) => JqElm) {
        elm.addClass('error')
        errorMessageFindFunc.bind(elm)('.invalid-feedback').show()
        //console.log(elm.next('.invalid-feedback').length)
        //console.log(elm.next('.invalid-feedback'))
        //elm.next('.invalid-feedback').show()
    },
    hideValidationError(elm: JqElm, errorMessageFindFunc: (selector: string) => JqElm) {
        elm.removeClass('error')
        errorMessageFindFunc.bind(elm)('.invalid-feedback').hide()
    },
    alertIfClientError(e:Error){
        if (e instanceof RestfulError && e.isClientError()) {
            UiUtils.alert(e.errorMessage)
        }
    }

}

export class BigCountBox {
    private currentVal: number
    private valBox: JqElm

    val(): number {
        let val = Number(this.valBox.val())
        if (isNaN(val)) {
            val = this.min
        }
        return val
    }

    reset() {
        this.valBox.val(this.min).change()
    }

    constructor(private boxElm: JqElm, private min: number, private max: number) {

        const ctrls = boxElm.find('.control').toArray()
        const minusCtrl = $(ctrls[0])
        const plusCtrl = $(ctrls[1])
        const valBox = boxElm.find('input[type=text]')
        valBox.change(() => {
            console.log("Changed")
            const val = this.val()
            if (val == this.min) {
                minusCtrl.addClass('end')
                plusCtrl.removeClass('end')
            } else if (val == this.max) {
                plusCtrl.addClass('end')
                minusCtrl.removeClass('end')
            } else {
                plusCtrl.removeClass('end')
                minusCtrl.removeClass('end')
            }
        })
        minusCtrl.click(() => {
            let val = this.val() - 1
            if (val < this.min) {
                val = this.min
            }
            this.valBox.val(val).change()
        })
        plusCtrl.click(() => {
            let val = this.val() + 1
            if (val > this.max) {
                val = this.min
            }
            this.valBox.val(val).change()
        })
        this.valBox = valBox
        this.reset()
    }

}

export abstract class GeneralElementCreator {
    private get tmpl(): TemplateExecutor {
        return this.lzTmpl.get()
    }

    private lzTmpl: Lazy<TemplateExecutor>
    abstract classId: string
    get tmplElmId(): string {
        return this.lzTmplElmId.get()
    }

    private lzTmplElmId: Lazy<string>

    constructor() {
        this.lzTmpl = new Lazy(() => {
            return template($(this.tmplElmId).get(0).outerHTML)
        })
        this.lzTmplElmId = new Lazy(() => {
            return '#tmpl_' + this.classId
        })
    }

    createJqElm(templateData?: any): JqElm {
        const elm = $(this.create(templateData))
            .removeClass('template')
            .removeAttr("id")
            .addClass(this.classId)
        if (templateData != null && templateData.id) {
            elm.attr('data-id', templateData.id)
        }
        return elm
    }

    private create(data?: object): string {
        return this.tmpl(data)
    }

}